import { Helpers } from '../../helpers';
import { IContinuousDrillingObligationTrigger } from '../../interfaces/icontinuous-drilling-obligation-trigger';
import { ContinuousDrillingObligation } from '../continuous-drilling-obligation';

export class ContinuousDrillingObligationTriggerBase {
  ContinuousDrillingObligationTriggerId: number;
  Name: string;
  Label: string;
  Value: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ContinuousDrillingObligations_FromCDOTrigger?: Array<ContinuousDrillingObligation> | null;
  ContinuousDrillingObligations_ToCDOTrigger?: Array<ContinuousDrillingObligation> | null;

  constructor(item?: IContinuousDrillingObligationTrigger) {
    if (item) {

      this.ContinuousDrillingObligationTriggerId = item.ContinuousDrillingObligationTriggerId;
      this.Name = item.Name;
      this.Label = item.Label;
      this.Value = item.Value;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ContinuousDrillingObligations_FromCDOTrigger = Helpers.createClassArray(ContinuousDrillingObligation, item.ContinuousDrillingObligations_FromCDOTrigger);
      this.ContinuousDrillingObligations_ToCDOTrigger = Helpers.createClassArray(ContinuousDrillingObligation, item.ContinuousDrillingObligations_ToCDOTrigger);
    }
  }
}